import React from "react";
import { Outlet } from "react-router-dom";

export default function SuperAdminLoginLayout() {
  return (
    <div className="login-layout login-layout--super-admin">
      <Outlet />
    </div>
  );
}
